type Unit1024 = 'B' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB';
type Unit1000 = 'B' | 'kB' | 'MB' | 'GB' | 'TB' | 'PB';

type FormatFileSizeOptions =
  | {
      base?: 1024;
      unit?: Unit1024;
      decimals?: number;
    }
  | {
      base: 1000;
      unit?: Unit1000;
      decimals?: number;
    };

export function fileSize(
  bytes: number,
  options: FormatFileSizeOptions = {}
): string {
  const { decimals = 2 } = options
  const base = options.base ?? 1024

  if (bytes === 0) return '0 B'

  const sizes: readonly string[] =
    base === 1024
      ? ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
      : ['B', 'kB', 'MB', 'GB', 'TB', 'PB']

  const unitIndex =
    options.unit !== undefined
      ? sizes.indexOf(options.unit)
      : Math.floor(Math.log(bytes) / Math.log(base))

  if (unitIndex === -1) {
    throw new Error(`Invalid unit: ${options.unit}`)
  }

  const value = bytes / Math.pow(base, unitIndex)
  const dm = decimals < 0 ? 0 : decimals

  return `${parseFloat(value.toFixed(dm))} ${sizes[unitIndex]}`
}